import gql from 'graphql-tag';

export const GENERATE_PARTNER_MAGIC_LINK = gql`
  mutation MutationGeneratePartnerMagicLink($input: GeneratePartnerMagicLinkInput!) {
    PartnerHubMutations {
      generatePartnerMagicLink(input: $input)
    }
  }
`;
